/* eslint-disable no-param-reassign, @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';
import {
  config,
  resolveFsFields,
  TFormFields,
  ApiError,
  JsonError,
  fetchJsonHandler,
  formatModel,
} from '@/utils';
import { EVENT_ON_GA_TRACKING } from '@/constants';
import { GAEvents } from '@/types';

export const fields = {
  name: 'name',
  phone: 'phone',
  term: 'term',
  dealer: 'dealerID',
} as const;

export type TFields = {
  [key: string]: { value: any; [key: string]: any };
};

type SliceState = {
  fields: TFields;
  loading: boolean;
  booked: boolean;
  error?: string;
};

const initialState: SliceState = {
  fields: {
    [fields.name]: { value: '' },
    [fields.phone]: { value: '' },
    [fields.dealer]: { value: '' },
    [fields.term]: { value: false },
  },
  booked: false,
  loading: false,
};

const bookSlice = createSlice({
  name: 'book',
  initialState,
  reducers: {
    updateFields: (state, action: PayloadAction<TFields>) => {
      state.fields = {
        ...state.fields,
        ...action.payload,
      };
    },
    resetForm: () => {
      return initialState;
    },
    bookingRequest: state => {
      state.loading = true;
    },
    bookingSuccess: state => {
      state.loading = false;
      state.booked = true;
    },
    bookingError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const booking = (formFields: TFormFields) => (dispatch: Dispatch) => {
  dispatch(bookSlice.actions.bookingRequest());

  const { car, ...values } = formFields;

  return fetch(
    `${config.get('formServiceApi')}${config.get('formServiceId')}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(resolveFsFields(values)),
    }
  )
    .then(fetchJsonHandler)
    .then(res => {
      dispatch(bookSlice.actions.bookingSuccess());
      document.dispatchEvent(new CustomEvent(EVENT_ON_GA_TRACKING, {
        detail: {
          gaEvent: GAEvents.bookingCar,
          data: {
            model: formatModel(car?.model || '')
          },
        },
      }));
    })
    .catch(error => {
      let errorMessage;

      if (error instanceof ApiError) {
        if (error.status === 400) {
          errorMessage = 'Отправлены не корректные данные';
        } else {
          errorMessage = 'Неизвестная ошибка';
        }
      } else if (error instanceof JsonError) {
        errorMessage = error.message;
      } else {
        errorMessage =
          'Сервис временно не доступен, попробуйте выполнить запрос позже';
      }

      dispatch(bookSlice.actions.bookingError(errorMessage));
    });
};

const actions = {
  ...bookSlice.actions,
  booking,
};

export { bookSlice as default, actions };
